/* eslint-disable */
import colors from '../../../../../public/colors'


export default theme => {
    const { mode } = theme.palette
    return {
        actionRow: {
            '& > button': {
                marginLeft: 'auto'
            },
            justifyContent: 'flex-end',
            height: '100%'
        },
        button: {
            '&.MuiButton-root': {
                border: '1px solid #006AC3',
                borderRadius: '4px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                height: '40px',
                marginLeft: '10px',
                width: '104px'
            },
            '&:disabled': {
                borderColor: 'rgba(0, 0, 0, 0.12)'
            }
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            paddingLeft: '89%',

            [theme.breakpoints.down('sm')]: {
                paddingLeft: '66%',
            }
        },
        contentDivider: {
            paddingTop: '25px'
        },
        divClass: {
            width: '100%'
        },
        fieldsContainer: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
            width: '100%'
        },
        positiveCriteria: {
            minWidth: '11% !important'
        },
        listItemIcon: {
            minWidth: '10% !important'
        },
        criteriaContainer: {
            margin: '32px 0 0 3px !important',
            padding: '0 !important',
            display: 'grid !important',
            gridTemplateColumns: '50% 47% !important',

        },
        supportText: {
            gridColumnStart: 1,
            gridColumnEnd: 3,
            paddingLeft: 'auto',
            paddingRight: '1% !important',
            marginLeft: '3.5%',

        },
        errorField: {
            '& > label': {
                color: `red !important`
            },
        },
        inputField: {
            [theme.breakpoints.down('xs')]: {
                color: colors[mode].cardDescription,
                fontFamily: 'Roboto',
                fontWeight: 400,
                lineHeight: '16px'
            },
            '& .MuiInput-underline:before': {
                // borderBottom: `1px solid ${colors[mode].borderBottom}`,
                [theme.breakpoints.down('sm')]: {
                    width: '100%'
                }
            },
            '& .MuiInput-underline:after': {
                borderBottom: `1px solid ${colors[mode].borderBottom}`,
                // width: '50%',
                [theme.breakpoints.down('sm')]: {
                    width: '100%'
                }
            },
            '& .MuiInput-underline.Mui-focused:after': {
                borderBottom: `1px solid ${colors[mode].borderBottom}`,
                [theme.breakpoints.down('sm')]: {
                    width: '100%'
                }
            },
            '& > div': {
                color: colors[mode].cardDescription,
                fontFamily: 'Roboto',
                fontWeight: 400,
                lineHeight: '16px'
            },
            '& > div input': {
                color: colors[mode].cardDescription,
                fontFamily: 'Roboto',
                fontWeight: 400,
                lineHeight: '16px',
            },
            '& > label': {
                color: `${colors[mode].cardDescription} !important`,
                fontFamily: 'Roboto',
                fontWeight: 400,
                lineHeight: '16px'
            },
            '& > p': {
                marginLeft: '0px',
                whiteSpace: 'pre-line',
                width: '200%',
                [theme.breakpoints.down('sm')]: {
                    width: '100%'
                }
            },
            color: colors[mode].cardDescription,
            fontFamily: 'Roboto',
            fontWeight: 400,
            lineHeight: '16px',
            width: '100%'
        },
        validField: {
            '& .MuiInput-underline:after': {
                borderBottom: `1px solid ${colors[mode].borderBottom} !important`,
                transform: 'scaleX(1)'
            }
        },
        introText: {
            paddingLeft: '24px',
            paddingRight: '24px',
            [theme.breakpoints.down('sm')]: {
                paddingLeft: '16px',
                paddingRight: theme.spacing(1),
                paddingTop: '16px'
            }
        },
        listItem: {
            padding: 0,
            marginBottom: '5px'
        },
        criteriaMainTitle: {
            fontSize: '0.875rem',
            color: colors[mode].cardDescription,
            fontWeight: 450,
            lineHeight: '1.25rem',
            letterSpacing: '0.17px',
        },
        criteriaTitle: {
            fontSize: '0.875rem',
            color: colors[mode].passwordCriteriaNotMet,
            fontWeight: 400,
            lineHeight: '1.25rem',
            letterSpacing: '0.17px',
            whiteSpace: 'pre-line',
            [theme.breakpoints.down('sm')]: {
                paddingLeft: '4px',
                wordBreak: 'break-word'
            }
        },
        nextButton: {
            '&.MuiButton-root': {
                backgroundColor: '#FEDF01',
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: '#003168',
                height: '32px',
                padding: '8px 16px',
                width: 'auto'
            }
        },
        nextButtonDisabled: {
            '&.MuiButton-root': {
                opacity: '50%'
            }
        },
        passwordContainer: {
            display: 'grid',
            gridTemplateColumns: '50%',
            paddingLeft: '24px',
            [theme.breakpoints.down('sm')]: {
                gridTemplateColumns: '95%',
            }
            // paddingTop: theme.spacing(2)
        },
        passwordCriteriaList: {
            marginTop: '5px'
        },
        secondListItem: {
            gap: '1%',
            marginBottom: '0'
        },
        passwordError: {
            color: colors[mode].passwordCriteriaNotMet,
        },
        passwordSuccess: {
            color: colors[mode].passwordCriteriaMet
        },
        secondDesc:{
            paddingTop: '0'
        },
        secondCriteria: {
            margin: '0',
            padding: '0',
            paddingTop: '3%',
            [theme.breakpoints.down('sm')]: {
                alignSelf: 'center',
            }

        },
        subTitle: {
            color: colors[mode].cardDescription,
            fontSize: '0.875rem',
            letterSpacing: '0.17px',
            lineHeight: '1.25rem'
        },
        helpText: {
            fontStyle: 'italic',
            margin: 0,
            padding: '2% 0px 24px 24px',
            [theme.breakpoints.down('md')]: {
                padding: '7px 24px'
            },
            [theme.breakpoints.down('sm')]: {
                padding: '0px 24px 0px 14px',
            }
        }
    }
}
